import { render, staticRenderFns } from "./SelectPlusConfig.vue?vue&type=template&id=079dd26a&scoped=true"
import script from "./SelectPlusConfig.vue?vue&type=script&lang=js"
export * from "./SelectPlusConfig.vue?vue&type=script&lang=js"
import style0 from "./SelectPlusConfig.vue?vue&type=style&index=0&id=079dd26a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dd26a",
  null
  
)

export default component.exports